import { render } from "./DangerTriangle.vue?vue&type=template&id=c2b0cd3a&ts=true"
import script from "./DangerTriangle.vue?vue&type=script&lang=ts"
export * from "./DangerTriangle.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__